<div class="item-grid-container shadow">
  <div class="commisions-holder">
    <div class="search-holder">
      <ul class="list-inline grid-top-actions w-90 mb-3">
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpFrom"
              disabled
              [min]="minFromDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              (dateChange)="changeFromDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpFrom"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpTo"
              disabled
              [min]="minToDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              (dateChange)="changeToDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpTo"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpTo disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item ">
          <div class="search-holder">
            <input
              type="text"
              placeholder="{{ 'pages.newRetailer.search' | translate }}"
              matInput
              class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              "
              (keyup)="quickSearch()"
              [(ngModel)]="searchValue"
            />
            <i
              color="primary"
              class="search-icon-holder"
              matSuffix
              mat-icon-button
              aria-label="Search"
            >
              <mat-icon>search</mat-icon>
            </i>
          </div>
        </li>
        <!-- <li class="list-inline-item">
                  <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
                </li> -->

        <li class="list-inline-item float-end">
          <button
          [disabled]="isButtonDisabled"
            mat-stroked-button
            color="primary"
            class=""
            (click)="exportData()"
          >
            <span translate class="translate">pages.newRetailer.download</span>
            <i class="mi mi-save-alt"></i>
          </button>
        </li>
      </ul>
    </div>
    <hr />
    <div class="stats-blks-holder" [ngStyle]="{'display': userRole === 'Sales Rep' ?'block':'none'}">
      <div class="row g-2">
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="card border-0 py-3 px-2 rounded bg-theme-light">
            <div class="row">
                <div class="sales-card">
                  <h5 translate>
                    pages.newRetailer.totalSales <br /><span class="values">
                      {{ this.summary?.totalSales | currency }}</span
                    >
                  </h5>
                </div>
              <!--<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 stats-each-blk">
                <div class="top-up-card">
                  <h5 translate>
                    Total Amount of Transactions <br /><span
                      class="values"
                    >
                      {{ this.summary?.totalTopupValue | currency }}</span
                    >
                  </h5>
                </div>
              </div>  -->
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-each-blk">
          <div class="card border-0 py-3 px-2 rounded bg-theme-light">
            <div class="row">
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 stats-each-blk">
                <div class="profit-card">
                  <h5 translate>
                    Sales Rep/Distr Commission <br /><span class="values">
                      {{ this.summary?.salesRepCommissionSummary | currency }}</span
                    >
                  </h5>
                </div>
              </div>
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 stats-each-blk">
                <div class="transactions-card">
                  <h5 translate>
                    pages.newRetailer.totalTransactions<br />
                    <span class="values">{{
                      this.summary["totalTransactions"]
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="stats-blks-holder" [ngStyle]="{'display': userRole === 'Super Admin' ? 'block' : 'none'}">
      <div class="row g-2">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
          <div class="card border-0 py-3 px-2 rounded bg-theme-light">
            <div class="row">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 stats-each-blk">
                <div class="sales-card">
                  <h5 translate>
                    pages.newRetailer.totalSales <br /><span class="values">
                      {{ this.summary?.totalSales | currency }}</span
                    >
                  </h5>
                </div>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 stats-each-blk">
                <div class="top-up-card">
                  <h5 translate>
                    Total TopupValue <br /><span
                      class="values"
                    >
                      {{ this.summary?.totalTopupValue | currency }}</span
                    >
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-each-blk">
          <div class="card border-0 py-3 px-2 rounded bg-theme-light">
            <div class="row">
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 stats-each-blk">
                <div class="profit-card">
                  <h5 translate>Sales Rep/Distr Commission
                    <br /><span class="values">
                      {{ this.summary?.salesRepCommissionSummary | currency }}</span
                    >
                  </h5>
                </div>
              </div>
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 stats-each-blk">
                <div class="transactions-card">
                  <h5 translate>
                    Total Transactions<br />
                    <span class="values">{{
                      this.summary["totalTransactions"]
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="mb-0" />
    <div class="realtime-transactions-grid-container">
      <ag-grid-angular
        style="width: 100%; height: 60vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>
